export default __webpack_public_path__ + "static/media/pression-oesophagienne.5f063508.svg";